import {Component} from '@angular/core';
import {Observable} from 'rxjs';
import {IDisplayColumn} from '@shared/library/crud-library/crud-list/crud-list.component';
import {Router} from '@angular/router';
import {Crud} from '@shared/services/crud';
import {AlertService, IAlert} from '@shared/services/alert.service';

@Component({
  template: ''
})
export abstract class AbstractCrudListComponent {

  observabledata?: Observable<any>;
  displayedcolumns: IDisplayColumn[] = [];
  entityroot: string;
  createlink: string;
  editpathprefix: string;
  editpathsuffix: string;

  constructor(
    protected router: Router,
    protected httpCrud: Crud,
    protected alertService: AlertService
  ) {

    // Set entity endpoint
    this.entityroot = '';

    this.editpathsuffix = '/edit';

    // Set here the list of columns to display
    this.displayedcolumns = [];

    // set here the list of entities
    this.observabledata = this.httpCrud.getEntities();
  }

  getPostTreatmentCallback(): any {
    return (data: any): any => {
      return data.results;
    };
  }

  deleteEntityHandler(): any {
    return (idvalue) => {
      return this.httpCrud.removeEntity(idvalue);
    };
  } // deleteEntityHandler

  deletePostTreatmentHandler() {
    return (idvalue, entityroot) => {
      this.router.navigateByUrl('/', {skipLocationChange: true})
        .then(() => this.router.navigate([entityroot])
          .then(() => {
            this.alertService.addAlert({
              type: 'success',
              title: 'Entity deleted',
              message: `The entity has been deleted successfully`,
            } as IAlert);
      }));
    };
  } // deletePostTreatmentHandler

  // Direct link accessible through the list
  // isKeyColumn true should be defined at this.displaycolumns
  // the [idColumnName]="'id'" should be defined at template
  getListEditPathCallback(): any {
    return (idvalue: string): string => {
      // return this.entityadminuri + '/' + idvalue + '/edit';
      return this.editpathprefix + idvalue + this.editpathsuffix;
    };
  }

}
